<template>
  <Paper class="product-template">
    <search @queries="searchQueries" :templateBlock='templateBlock' :queryBlock='queryBlock'
    @newPush="newPush" ref="search" @download="download" @refreshPage="refreshPage" class="product-template-search"></search>
   <div class="showTable">
        <product-table
            @coding="openCoding"
            :tableData="tableData"
            @gotoPublic="gotoPublic"
            @indexState="indexState"
        ></product-table>
   </div>
   <div class="product-template-button-list">
        <el-button class="product-template-search-left sn-search-default-button" size="mini" @click="download" :loading="templateBlock">
            {{$translate('lang.E3202102260007', { defaultText: '模板下载' })}}
        </el-button>
        <el-upload class="product-template-search-left"  ref="upload" action='' :http-request="submitUpload" multiple :unlink-panels="false" :show-file-list="false" accept=".xls">
            <el-button class="sn-search-default-button" size="mini">{{$translate('lang.E3202102260006', { defaultText: '批量导入' })}}</el-button>
        </el-upload>
        <el-button class="product-template-search-left" @click="newPush" type="primary" size="mini" icon="el-icon-plus" >
            {{$translate('lang.E3202102260005', { defaultText: '新增' })}}
        </el-button>
   </div>
    <page-list v-if="pageState" :pageMenu="pageMenu" @changeCurrent="currentDom" @changeSize="sizeDom" class="product-template-pagelist"></page-list>
  </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import { templateUpload,
    queryTemplate,
    templateState
} from '../../../api/product';
import search from './search';
import productTable from './table';
import pageList from './pageList';
import request from '@/utils/http';

export default {
    name: 'product',
    data() {
        return {
            pageState: true,
            queryBlock: false,
            templateBlock: false,
            dialogVisible: false,
            productInf: {
                identifying: '',
                category: '',
                name: '',
                state: null,
                explain: ''
            },
            pageMenu: {
                totalCount: 0,
                currentPage: 1,
                pageNo: 1, // 初始页
                pageSize: 10, // 每页个数
                pageSizes: [10, 20, 30, 40]
            },
            tableData: []
        };
    },
    methods: {
        searchQueries() {
            this.pageState = false;
            this.pageMenu.pageNo = 1;
            this.queryBlock = true;
            this.pushQueries();
            this.$nextTick(() => {
                this.pageState = true;
            });
        },
        // 上传 模板后，刷新页面
        refreshPage() {
            this.pushQueries();
        },
        // 发送查询请求
        pushQueries() {
            const queries = this.$refs.search.queries;
            queries.pageNo = this.pageMenu.pageNo;
            queries.pageSize = this.pageMenu.pageSize;
            if (this.$refs.search.timeHorizon) {
                queries.startTime = this.$refs.search.timeHorizon[0];
                queries.endTime = this.$refs.search.timeHorizon[1];
            } else {
                queries.startTime = '';
                queries.endTime = '';
            }
            queryTemplate(queries).then(res => {
                if (+res.code === 0) {
                    this.tableData = res.data.list;
                    this.pageMenu.totalCount = res.data.totalCount;
                }
                this.queryBlock = false;
            }).catch(() => {
                this.queryBlock = false;
            });
        },
        // 点击产品模板编码，发送请求，这里为假数据
        openCoding(row) {
            Object.keys(this.productInf).forEach(key => {
                this.productInf[key] = row[key];
            });
            this.dialogVisible = true;
        },
        // 发送修改请求
        pushInf() {
            this.dialogVisible = false;
        },
        // 分页1
        currentDom(val) {
            this.pageMenu.pageNo = val;
            this.pushQueries();
        },
        // 分页2
        sizeDom(val) {
            this.pageMenu.pageSize = val;
            this.pushQueries();
        },
        // 跳转公共属性，传参
        gotoPublic(row) {
            this.$router.push({
                path: '/publicproperty',
                query: { id: row.id }
            });
        },
        // 新增
        newPush() {
            this.$router.push({
                path: '/publicproperty'
            });
        },
        // 发送新增模板
        pushNew() {
            this.$refs.newList.newLists = {};
            this.newTemplate = false;
        },
        // 模板下载
        download() {
            this.templateBlock = true;
            const p1 = new Promise(resolve => {
                resolve(params);
            });
            const params = {};
            p1.then(() => {
                request({
                    url: '/api-sn/product/productTemplates/download',
                    method: 'get',
                    data: {
                        ...params
                    },
                    responseType: 'arraybuffer'
                })
                    .then(res => {
                        if (res) {
                            const blob = new Blob([res], {
                                type: 'application/x-excel;charset=UTF-8'
                            });
                            const objectUrl = URL.createObjectURL(blob);
                            if (window.navigator.msSaveBlob) {
                                try {
                                    window.navigator.msSaveBlob(blob, this.$translate('lang.E3202102260001', { defaultText: '模板.xls' }));
                                } catch (e) {
                                }
                            } else {
                                var a = document.createElement('a');
                                a.href = objectUrl;
                                a.download = this.$translate('lang.E3202102260001', { defaultText: '模板.xls' });
                                a.click();
                            }
                            this.templateBlock = false;
                        }
                    })
                    .catch(() => {
                        this.$message.error(this.$translate('lang.EXC202102260001', { defaultText: '导出失败' }));
                        this.templateBlock = false;
                    });
            });
        },
        // 主页状态更改
        indexState(row) {
            let rows = '';
            this.$confirm(this.$translate('lang.EXC202102260004', { defaultText: '此操作将进行状态更改, 是否继续?' }),
                this.$translate('lang.E3202102220028', { defaultText: '提示' }), {
                    confirmButtonText: this.$translate('lang.E3202101270001', { defaultText: '确定' }),
                    cancelButtonText: this.$translate('lang.E3202101270002', { defaultText: '取消' }),
                    type: 'warning'
                })
                .then(() => {
                    if (row.status === 'Y') {
                        rows = 'N';
                    } else {
                        rows = 'Y';
                    }
                    templateState({
                        id: row.id,
                        version: row.version,
                        status: rows
                    }).then(res => {
                        this.$message.success(this.$translate('lang.EXC202102260002', { defaultText: '更改成功' }));
                        this.pushQueries(this.$refs.search.queries);
                    });
                })
                .catch(() => {
                    this.$message.warning(this.$translate('lang.EXC202102260003', { defaultText: '取消更改' }));
                });
        },
        submitUpload(item) {
            const testmsg = item.file.name.substring(item.file.name.lastIndexOf('.') + 1);
            if (testmsg === 'xls') {
                const form = new FormData();
                form.append('file', item.file);
                templateUpload(form).then(res => {
                    if (res.code === '0') {
                        this.$message.success(this.$translate('lang.EXC202102260005', { defaultText: '导入成功' }));
                    }
                    this.$refs.upload.clearFiles();
                    this.$emit('refreshPage');
                }).catch(() => {
                    this.$refs.upload.clearFiles();
                });
            } else {
                this.$message.warning(this.$translate('lang.EXC202102260006', { defaultText: '表格上传类型不正确' }));
                this.$refs.upload.clearFiles();
            }
        }
    },
    components: {
        Paper,
        search,
        productTable,
        pageList
    },
    activated() {
        this.pushQueries();
    }
};
</script>
<style lang="less">
.product-template{
    .showTable{
        .el-table {
            height: calc(100vh - 220px) !important;
        }
        .row-bg {
            margin-top: 20px;
        }
    }
    .product-template-button-list{
        float: left;
        margin-top: 20px;
    }
    .product-template-search-left{
        float: right;
        margin-right: 10px;
    }
    .product-template-pagelist{
        text-align: right;
        margin-top: 20px;
        background-color: #ffffff;
    }
}
</style>